import { Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './mobile-case-tracking-pagination.module.scss';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const getVisiblePages = (): (number | string)[] => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages: (number | string)[] = [1];

    if (currentPage <= 3) {
      pages.push(2, 3, '...', totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push('...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push('...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }

    return pages;
  };

  return (
    <div className={styles.pagination}>
      <button
        className={styles.navButton}
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label='Previous page'
      >
        <Icon icon={ICONS_ENUM.NAVIGATION_CHEVRON_LEFT} />
      </button>

      {getVisiblePages().map((page, idx) =>
        page === '...' ? (
          <span key={`ellipsis-${idx}`} className={styles.ellipsis}>
            ...
          </span>
        ) : (
          <button
            key={`page-${page}`}
            className={`${styles.pageButton} ${page === currentPage ? styles.active : ''}`}
            onClick={() => onPageChange(page as number)}
            aria-label={`Go to page ${page}`}
            aria-current={page === currentPage ? 'page' : undefined}
          >
            <Typography
              variant={Typography.VARIANT.B3}
              weight={Typography.WEIGHT.NORMAL}
              className={styles.statusText}
            >
              {page}
            </Typography>
          </button>
        )
      )}

      <button
        className={styles.navButton}
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label='Next page'
      >
        <Icon icon={ICONS_ENUM.NAVIGATION_CHEVRON_RIGHT} />
      </button>
    </div>
  );
}
